export default __webpack_public_path__ + "static/media/bg.d4d132a0.jpg";